import React from 'react'
import { Row, Col } from "react-bootstrap";

export const FichaTecnica = ({arrayVehiculos, vehiculos}) => {
  return (
    <div>
        <div>
          <h3 className="newtitlenuevasfichastecnicas text-center pt-4 pb-3">Seguridad</h3>
          <Row>
            {arrayVehiculos
              .filter((v) => v.name === vehiculos)
              .map((i) =>
                i.seguridad23.map((item, index) => (
                  <Col md={3} xs={6}>
                    <img src={item.foto} className="img-fluid efectoImagenes" />
                    <h5 className="nuevotitulofichastecnicasmini">{item.titulo}</h5>
                  </Col>
                ))
              )}
          </Row>
          <h3 className="newtitlenuevasfichastecnicas text-center pt-4 pb-3">Tecnología</h3>
          <Row>
            {arrayVehiculos
              .filter((v) => v.name === vehiculos)
              .map((i) =>
                i.tecnologia23.map((item, index) => (
                  <Col md={3} xs={6}>
                    <img src={item.foto} className="img-fluid" />
                    <h5 className="nuevotitulofichastecnicasmini">{item.titulo}</h5>
                  </Col>
                ))
              )}
          </Row>
        </div>
        <Row>
          <Col className="text-center pt-4 pb-0" md={12}>
            <a
              href="https://centraljeep.divit.com.ar/wp-content/uploads/2023/03/FT-CRONOS-MY23-1.pdf"
              className="linksimpledefault text-center"
              target="_blank"
              rel="noreferrer"
            >
              Ver ficha técnica completa {'>'}
            </a>
          </Col>
        </Row>
    </div>
  )
}
